import { Sprite, Text, Texture } from "pixi.js";
import { BitmapTextStyles, standardButtonOptions } from "../logic/Globals";
import { BasicScene } from "./BasicScene";
import { Button } from "../prefabs";

const disconnectMessages: string[] = [
  "Uh-oh! Looks like a mammoth might’ve tripped over the connection!\nTry reloading to get back in.",
  "Oops! A caveman just stepped on the connection.\nReload to fix it—quick, before he does it again!",
  "Connection lost! It seems our ancient warriors got distracted by a saber-toothed tiger.\nReload to bring them back!",
  "Oops! Your connection was lost, maybe a woolly rhino used it as a scratching post.\nTry reloading!",
  "Uh-oh, the campfire smoke must have blocked the signal.\nTry reloading to reconnect!",
  "It seems like the tribe got distracted by a passing mammoth.\nTry reloading to get back to camp!",
  "A wild animal wandered off with the connection!\nReload to bring it back.",
  "Oops! A prehistoric storm must have blown away the connection.\nReload and try again!",
  "The signal fire went out!\nTry reloading to rekindle your connection.",
  "A dinosaur stomped through your connection!\nReload to dodge its path."
];

export class DisconnectedScene extends BasicScene {
  constructor() {
    super("DisconnectedScene");
    this.Setup();
  }

  private Setup() {
    if(this.sceneManager.MasterHudOverlay)
      this.sceneManager.MasterHudOverlay.visible = false;
    
    const screen = this.sceneManager.Application.screen;
    const text = this.getRandomDisconnectMessage(); 
    
    const txtMessage = new Text({
      text: text,
      style: {...BitmapTextStyles.LabelCaptionStyle, align: "center" },
    });
    txtMessage.position.set((screen.width - txtMessage.width) / 2, 50);
    this.addChild(txtMessage);
    
    const size = screen.height - txtMessage.y - txtMessage.height - 5;
    const img = new Sprite(Texture.from("/assets/gui/disconnected.png"));    
    img.anchor.set(0.5, 0);
    img.height = size;
    img.width = size;
    img.position.set(screen.width / 2, txtMessage.y + txtMessage.height + 5);
    this.addChild(img);

    const txtError = new Text({
      text: "Error: Connection lost",
      style: BitmapTextStyles.LabelTextStyle,
      x: 50,
      y: screen.height - 50,
    });
    this.addChild(txtError);

    const btnConnect = new Button(standardButtonOptions);
    btnConnect.position.set(txtError.x + txtError.width + 10, screen.height - btnConnect.height - 5);
    btnConnect.caption = "try again";
    btnConnect.onClick = () => window.location.reload();
    this.addChild(btnConnect);
  }

  private getRandomDisconnectMessage(): string {
    const randomIndex = Math.floor(Math.random() * disconnectMessages.length);
    return disconnectMessages[randomIndex];
  }
}
